

















































import { Vue, Component, Prop } from "vue-property-decorator";
import * as XLSX from "xlsx";
import { CajaChica } from "@/typings/store/plugins/easyFirestore/cajaChicas";

const COLUMNAS_PLANTILLA = [
  "Periodo", "Fecha", "Rut Proveedor", "Nombre Proveedor", "Acción", "Ingresos", "Egresos",
  "Documento", "Concepto", "Descripcion",
] as const;

const ACCIONES_VALIDAS = ["ABONAR", "PAGAR", "SALDO PERIODO ANTERIOR"];
const DOCUMENTOS_VALIDOS = [
  "SALDO INICIAL", "SALDO PERIODO ANTERIOR", "BOLETA DE PAGO", "C. DE CREDITO FISCAL",
  "FACTURA COMERCIAL", "NOTA DE CREDITO", "NOTA DE REVISIÓN", "NOTA DE ENVIO",
];

function toStr(v: unknown): string {
  if (v == null) return "";
  if (typeof v === "number" && !Number.isNaN(v)) return String(v);
  return String(v).trim();
}

function toNum(v: unknown): number {
  if (v == null || v === "") return 0;
  if (typeof v === "number" && !Number.isNaN(v)) return Math.round(v);
  const s = String(v).replace(/\./g, "").replace(",", ".").trim();
  const n = parseFloat(s);
  return Number.isNaN(n) ? 0 : Math.round(n);
}

@Component({})
export default class CargarExcelCajaChicas extends Vue {
  @Prop({ type: Array, required: true }) readonly cajaChicas!: CajaChica[];

  archivo: File | null = null;
  cargando = false;
  mensajes: string[] = [];
  archivoError: string[] = [];
  mensajeEsError = false;

  get siguienteNumero(): number {
    if (this.cajaChicas.length === 0) return 1;
    const max = Math.max(...this.cajaChicas.map((c) => c.numero ?? 0));
    return max + 1;
  }

  get periodoActual(): string {
    const now = new Date();
    const mes = String(now.getMonth() + 1).padStart(2, "0");
    return `01-${mes}-${now.getFullYear()}`;
  }

  descargarPlantilla(): void {
    const hoy = new Date();
    const fechaEjemplo = `${String(hoy.getDate()).padStart(2, "0")}-${String(hoy.getMonth() + 1).padStart(2, "0")}-${hoy.getFullYear()}`;
    const filaEjemplo = [
      this.periodoActual,
      fechaEjemplo,
      "12.345.678-9",
      "PROVEEDOR EJEMPLO S.A",
      "PAGAR",
      "0",
      "50000",
      "FACTURA COMERCIAL",
      "N° 123",
      "Descripción del gasto",
    ];
    const ws = XLSX.utils.aoa_to_sheet([[...COLUMNAS_PLANTILLA] as string[], filaEjemplo]);
    ws["!cols"] = [{ wch: 12 }, { wch: 12 }, { wch: 14 }, { wch: 28 }, { wch: 22 }, { wch: 10 }, { wch: 12 }, { wch: 20 }, { wch: 12 }, { wch: 24 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "C.C. Talca Mall");
    XLSX.writeFile(wb, "plantilla_caja_chica_talca_mall.xlsx");
  }

  validarColumnas(primeraFila: Record<string, unknown>): boolean {
    const keys = new Set(Object.keys(primeraFila).map((k) => String(k).trim()));
    return COLUMNAS_PLANTILLA.every((col) => keys.has(col));
  }

  parsearFila(
    row: Record<string, unknown>,
    numero: number,
    index: number
  ): { doc: CajaChica | null; error?: string } {
    const periodo = toStr(row["Periodo"]).trim() || this.periodoActual;
    const fecha = toStr(row["Fecha"]).trim();
    const rutProveedor = toStr(row["Rut Proveedor"]).trim().toUpperCase();
    const nombreProveedor = toStr(row["Nombre Proveedor"]).trim().toUpperCase();
    const accion = toStr(row["Acción"]).trim();
    const ingreso = toNum(row["Ingresos"]);
    const egreso = toNum(row["Egresos"]);
    const documento = toStr(row["Documento"]).trim();
    const concepto = toStr(row["Concepto"]).trim();
    const descripcion = toStr(row["Descripcion"]).trim().toUpperCase();

    if (!fecha) return { doc: null, error: `Fila ${index + 2}: Fecha es obligatoria` };
    if (!rutProveedor) return { doc: null, error: `Fila ${index + 2}: Rut Proveedor es obligatorio` };
    if (!nombreProveedor) return { doc: null, error: `Fila ${index + 2}: Nombre Proveedor es obligatorio` };
    if (!ACCIONES_VALIDAS.includes(accion)) {
      return { doc: null, error: `Fila ${index + 2}: Acción debe ser una de: ${ACCIONES_VALIDAS.join(", ")}` };
    }
    if (!DOCUMENTOS_VALIDOS.includes(documento)) {
      return { doc: null, error: `Fila ${index + 2}: Documento debe ser uno de la lista (ej: FACTURA COMERCIAL)` };
    }
    if (!concepto) return { doc: null, error: `Fila ${index + 2}: Concepto es obligatorio` };
    if (!descripcion) return { doc: null, error: `Fila ${index + 2}: Descripcion es obligatoria` };

    const doc: CajaChica = {
      periodo,
      checkbox: false,
      numero,
      fecha,
      saldoActual: 0,
      rutProveedor,
      nombreProveedor,
      accion,
      ingreso: String(ingreso),
      egreso: String(egreso),
      documento,
      concepto,
      descripcion,
    };
    return { doc };
  }

  async cargar(): Promise<void> {
    if (!this.archivo) {
      this.archivoError = ["Seleccione un archivo"];
      return;
    }
    this.cargando = true;
    this.mensajes = [];
    this.mensajeEsError = false;
    this.archivoError = [];

    try {
      const data = await this.archivo.arrayBuffer();
      const wb = XLSX.read(data, { type: "array" });
      const firstSheet = wb.Sheets[wb.SheetNames[0]];
      const json: Record<string, unknown>[] = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });

      if (json.length === 0) {
        this.mensajeEsError = true;
        this.mensajes.push("El archivo no tiene filas de datos.");
        this.cargando = false;
        return;
      }

      if (!this.validarColumnas(json[0])) {
        this.mensajeEsError = true;
        this.mensajes.push("Las columnas del archivo no coinciden con la plantilla.");
        this.mensajes.push("Descargue la plantilla y use exactamente esos nombres de columna (primera fila).");
        this.archivoError = ["Plantilla inválida"];
        this.cargando = false;
        return;
      }

      const docs: CajaChica[] = [];
      const errores: string[] = [];
      let siguienteNum = this.siguienteNumero;

      for (let i = 0; i < json.length; i++) {
        const { doc, error } = this.parsearFila(json[i], siguienteNum, i);
        if (error || !doc) {
          if (error) errores.push(error);
          continue;
        }
        docs.push(doc);
        siguienteNum++;
      }

      if (errores.length > 0) {
        this.mensajeEsError = true;
        this.mensajes.push(...errores.slice(0, 15));
        if (errores.length > 15) this.mensajes.push(`... y ${errores.length - 15} errores más.`);
        this.mensajes.push("Corrija el Excel y vuelva a importar.");
        this.cargando = false;
        return;
      }

      if (docs.length === 0) {
        this.mensajeEsError = true;
        this.mensajes.push("No hay filas válidas para importar.");
        this.cargando = false;
        return;
      }

      this.$emit("carga-excel", docs);
      this.mensajeEsError = false;
      this.mensajes.push(`Importación correcta: ${docs.length} registro(s) cargados.`);
      this.mensajes.push("Los números se asignaron en correlativo.");
      this.archivo = null;
    } catch (e) {
      this.mensajeEsError = true;
      this.mensajes.push("Error al leer el archivo. Asegúrese de que sea un Excel (.xlsx) válido.");
      this.archivoError = ["Error de lectura"];
    } finally {
      this.cargando = false;
    }
  }
}
